class YoienServerConfig {
  YOIEN_SERVER = {
    MAX_RETRY_COUNT: 2,
    // TODO:環境毎の値が決まり次第設定する。
    LOCAL_API_KEY: 'local_yoien',
    DEV_API_KEY: 'dev_yoien',
    TEST_API_KEY: 'DLFojk2aEU33Nixuv3J6Q7mv5h1s2st86RNHtvHr',
    STG_API_KEY: 'pixnIkqgeD6T0NNyiTy939ZcTPZGyUTo5NLiX2TU',
    PROD_API_KEY: 'prod_yoien',
  };
  YOIEN_INTERNAL_API_NAME = {
    FAULT_NOTIFICATION_LIST: '/projects/{projectId}/faultNotifications',
    ANNOUNCEMENT_INFORMATION_LIST: '/projects/{projectId}/announcementInformations',
    SETTING_EMAIL_NOTIFICATION: '/projects/{projectId}/emailNotificationSettings',
    SETTING_POPUP_NOTIFICATION: '/projects/{projectId}/popupNotificationSettings',
    CONTROL_GROUP_LIST: '/projects/{projectId}/controlGroups',
    CONTROL_GROUPS: '/projects/{projectId}/controlGroups/{controlGroupId}',
    CONTENT_LIST: '/projects/{projectId}/contents',
    CONTENTS: '/projects/{projectId}/contents/{contentId}',
    SCENE_LIST: '/projects/{projectId}/scenes',
    SCENE_SUMMARY_LIST: '/projects/{projectId}/scenes/summary',
    SCENES: '/projects/{projectId}/scenes/{sceneId}',
    SCENENAME: '/projects/{projectId}/controlGroups/{controlGroupId}/scenename',
    PROGRESS: '/projects/{projectId}/controlGroups/{controlGroupId}/scenes/{sceneId}/progress',
    SCHEDULES: '/projects/{projectId}/controlGroups/{controlGroupId}/schedules',
    SCHEDULES_CONTROL_GROUP: '/projects/{projectId}/schedules/{scheduleNo}/controlGroups',
    CALENDARS: '/projects/{projectId}/controlGroups/{controlGroupId}/calendars',
    FILE_RESTRICTION_STATUS: '/projects/{projectId}/fileRestrictionStatus',
    DATA_TRANSMISSION_AVAILABILITY:
      '/projects/{projectId}/controlGroups/{controlGroupId}/dataTransmissionAvailabilities',
    DATA_RECEPTION_AVAILABILITY:
      '/projects/{projectId}/controlGroups/{controlGroupId}/dataReceptionAvailabilities',
    DATA_TRANSFER_AVAILABILITY:
      '/projects/{projectId}/controlGroups/{controlGroupId}/dataTransferAvailabilities',
    CONTENTS_IN_USE: '/projects/{projectId}/contentsInUse',
    SCENES_IN_USE: '/projects/{projectId}/scenesInUse',
    TMPFILE_UPLOAD_URL: '/temporaryFileUploadUrl',
    HOLIDAY_SETTING: '/holidaySetting',
    DATA_TRANSCEIVER_DETAIL: '/projects/{projectId}/dataTransceiverDetail',
    FAULT_NOTIFICATION_PUT: '/projects/{projectId}/faultNotifications/check',
    REPORT_EMBED_URL: '/projects/{projectId}/reportEmbedUrl',
    ANNOUNCEMENT_INFORMATION_REGIST_PUT: '/projects/{projectId}/announcementInformations',
    SETTING_EMAIL_NOTIFICATION_PUT: '/projects/{projectId}/emailNotificationSettings',
    SETTING_POPUP_NOTIFICATION_PUT: '/projects/{projectId}/popupNotificationSettings',
    CONTROL_GROUP_REGIST_POST: '/projects/{projectId}/controlGroups',
    CONTROL_GROUPS_PUT: '/projects/{projectId}/controlGroups/{controlGroupId}',
    CONTENT_REGIST_POST: '/projects/{projectId}/contents',
    CONTENTS_PUT: '/projects/{projectId}/contents/{contentId}',
    SCENE_REGIST_POST: '/projects/{projectId}/controlGroups/{controlGroupId}/scenes',
    SCENES_PUT: '/projects/{projectId}/controlGroups/{controlGroupId}/scenes/{sceneId}',
    SCENES_INFO_PUT: '/projects/{projectId}/controlGroups/{controlGroupId}/scenes/{sceneId}/infos',
    CW_SCENES_INFO_PUT: '/projects/{projectId}/controlGroups/{controlGroupId}/scenes/cw/infos',
    SCENES_SYNTHESIZE_POST:
      '/projects/{projectId}/controlGroups/{controlGroupId}/scenes/synthesize',
    SCENENAME_PUT: '/projects/{projectId}/controlGroups/{controlGroupId}/scenename',
    SCENENAME_INFO_PUT: '/projects/{projectId}/controlGroups/{controlGroupId}/scenename/infos',
    SCHEDULES_PUT: '/projects/{projectId}/controlGroups/{controlGroupId}/schedules',
    SCHEDULES_INFO_PUT: '/projects/{projectId}/controlGroups/{controlGroupId}/schedules/infos',
    CALENDARS_PUT: '/projects/{projectId}/controlGroups/{controlGroupId}/calendars',
    CALENDARS_INFO_PUT: '/projects/{projectId}/controlGroups/{controlGroupId}/calendars/infos',
    FILE_RESTRICTION_STATUS_PUT: '/projects/{projectId}/fileRestrictionStatus',
    CONTENTS_IN_USE_POST: '/projects/{projectId}/contentsInUse',
    SCENES_IN_USE_POST: '/projects/{projectId}/scenesInUse',
    SCENARIO_PUT: '/projects/{projectId}/controlGroups/{controlGroupId}/scenario',
    MAINTENANCES_PUT: '/projects/{projectId}/controlGroups/{controlGroupId}/maintenances',
    FAULT_NOTIFICATION_POST: '/projects/{projectId}/faultNotifications',
    LOGS_POST: '/projects/{projectId}/logs',
    SEND_FILE_POST: '/projects/{projectId}/sendFile',
    RECEIVE_FILE_POST: '/projects/{projectId}/receiveFile',
    DATA_TRANSCEIVER_DETAIL_PUT: '/projects/{projectId}/dataTransceiverDetail',
    DATA_TRANSCEIVER_BATCH_POST:
      '/projects/{projectId}/controlGroups/{controlGroupId}/dataTransceiverBatch',
    FAULT_NOTIFICATIONS_DELETE: '/projects/{projectId}/faultNotifications',
    CONTROL_GROUPS_DELETE: '/projects/{projectId}/controlGroups/{controlGroupId}',
    CONTENTS_DELETE: '/projects/{projectId}/contents/{contentId}',
    SCENES_DELETE: '/projects/{projectId}/controlGroups/{controlGroupId}/scenes/{sceneId}',
    SCHEDULES_DELETE: '/projects/{projectId}/controlGroups/{controlGroupId}/schedules/{scheduleNo}',
    CONTENTS_IN_USE_DELETE: '/projects/{projectId}/contentsInUse',
    SCENES_IN_USE_DELETE: '/projects/{projectId}/scenesInUse',
    NOT_CREATED_SCENE_PREVIEW:
      '/projects/{projectId}/controlGroups/{controlGroupId}/scenes/preview/create',
    NOT_COMPOSITION_SCENE_PREVIEW:
      '/projects/{projectId}/controlGroups/{controlGroupId}/scenes/preview/synthesize',
    CREATED_SCENE_PREVIEW:
      '/projects/{projectId}/controlGroups/{controlGroupId}/scenes/{sceneId}/preview/created',
    STOP_SCENE_PREVIEW:
      '/projects/{projectId}/scenes/streamingProcessIds/{streamingProcessId}/preview',
  };
}

class CloudCommonServerConfig {
  CLOUD_COMMON_SERVER = {
    MAX_RETRY_COUNT: 2,
    // TODO:環境毎の値が連携され次第設定する。
    LOCAL_API_KEY: '',
    DEV_API_KEY: 'DLFojk2aEU33Nixuv3J6Q7mv5h1s2st86RNHtvHr',
    TEST_API_KEY: 'DLFojk2aEU33Nixuv3J6Q7mv5h1s2st86RNHtvHr',
    STG_API_KEY: 'pixnIkqgeD6T0NNyiTy939ZcTPZGyUTo5NLiX2TU',
    PROD_API_KEY: 'sd8XDZdwmZ5ItMYsFQ1LvywG8vk5xk26xJk1VzDg',
  };
  CLOUD_COMMON_API_NAME = {
    GET_PROJECT: '/projects/{projectId}',
    GET_USER: '/projects/{projectId}/users/{userId}',
    CONTROLLER_GROUPS: '/devices/controller-groups',
    CONTROLLER_GROUP: '/devices/controller-groups/{id}',
    CONTROLLER: '/devices/controllers/{id}',
    CONTROLLER_EMITS: '/devices/controllers/{id}/emits',
    CONTROLLER_EMIT_LAMPS: '/devices/controllers/{controllerId}/emits/{emitId}/lamps',
    USER_INFO: '/projects/{project}/users/{userId}',
    EMAILS: '/projects/{project}/emails',
  };
}

export default defineNuxtPlugin(() => {
  return {
    provide: {
      YOIEN_SERVER_CONFIG: new YoienServerConfig(),
      CLOUD_COMMON_SERVER_CONFIG: new CloudCommonServerConfig(),
    },
  };
});
